import React from 'react';
import { PortfolioNameEditor } from '@/components/portfolio/build/PortfolioNameEditor';
import { Badge } from '@/components/ui/badge';

interface PortfolioHeaderBarProps {
  portfolio: any;
  isEditingName: boolean;
  portfolioName: string;
  onNameChange: (name: string) => void;
  onSave: () => void;
  onEditStart: () => void;
  onEditCancel: () => void;
  type?: string;
  rightActions?: React.ReactNode;
}

function getDisplayText(t?: string) {
  switch (t) {
    case 'model':
      return 'Model Portfolio';
    case 'personal':
      return 'Personal Portfolio';
    case 'client':
      return 'Client Portfolio';
    default:
      return undefined;
  }
}

function getVariant(t?: string) {
  switch (t) {
    case 'model':
      return 'default' as const;
    case 'personal':
      return 'secondary' as const;
    case 'client':
      return 'outline' as const;
    default:
      return 'default' as const;
  }
}

export function PortfolioHeaderBar({
  portfolio,
  isEditingName,
  portfolioName,
  onNameChange,
  onSave,
  onEditStart,
  onEditCancel,
  type,
  rightActions,
}: PortfolioHeaderBarProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
      <div className="flex-1 min-w-0">
        <PortfolioNameEditor
          portfolio={portfolio}
          isEditingName={isEditingName}
          portfolioName={portfolioName}
          onNameChange={onNameChange}
          onSave={onSave}
          onEditStart={onEditStart}
          onEditCancel={onEditCancel}
        />
      </div>
      <div className="flex items-center gap-2 sm:h-12 flex-shrink-0">
        {type && (
          <Badge variant={getVariant(type)} className="whitespace-nowrap">
            {getDisplayText(type)}
          </Badge>
        )}
        {rightActions}
      </div>
    </div>
  );
}
